import { useId } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useIntl } from 'react-intl'

import type { TagBadgeProps } from './TagBadge.types'
import { getTagColorStyles } from './tagging.utils'
import { TagPill } from './TagPill'

export const TagBadge = (props: TagBadgeProps) => {
  const {
    name,
    color,
    disableRemove,
    emphasized,
    inherited,
    inheritedFrom,
    onRemove,
    onNameClick,
    removeDataE2e,
    showRemove,
  } = props
  const intl = useIntl()
  const tooltipId = useId()
  const canRemove = showRemove && !inherited

  const pill = (
    <TagPill
      aria-describedby={inherited && !onNameClick ? tooltipId : undefined}
      className="TagBadge"
      style={getTagColorStyles(color)}
      tabIndex={inherited && !onNameClick ? 0 : undefined}
    >
      <span
        aria-describedby={inherited && onNameClick ? tooltipId : undefined}
        className={`TagBadge-name ${onNameClick ? 'TagBadge-name--clickable' : ''}`}
        onClick={onNameClick}
        onKeyDown={
          onNameClick
            ? (e: React.KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  onNameClick()
                }
              }
            : undefined
        }
        role={onNameClick ? 'button' : undefined}
        tabIndex={onNameClick ? 0 : undefined}
      >
        {emphasized ? <strong>{name}</strong> : name}
      </span>
      {canRemove && (
        <button
          aria-label={intl.formatMessage({ id: 'Tags_remove_tag' }, { name })}
          className="TagBadge-remove"
          data-e2e={removeDataE2e}
          disabled={disableRemove}
          onClick={onRemove}
          type="button"
        >
          &#x2715;
        </button>
      )}
    </TagPill>
  )

  if (!inherited) {
    return pill
  }

  const tooltip = inheritedFrom
    ? intl.formatMessage({ id: 'Tags_inherited_from' }, { name: inheritedFrom })
    : intl.formatMessage({ id: 'Tags_inherited_from_employee' })

  return (
    <OverlayTrigger
      overlay={
        <Tooltip className="TagBadge-tooltip" id={tooltipId}>
          {tooltip}
        </Tooltip>
      }
      placement="top"
      trigger={['hover', 'focus']}
    >
      {pill}
    </OverlayTrigger>
  )
}
